import util from '@bmp-vue/core/api/util'

const controller = 'TemplateEmail'
export default Object.assign({}, util.GetCrud(controller, null))
